import * as XLSX from "xlsx";
import { formatFCFA } from "./fcfa";

export function exportToExcel(filename, sheets) {
  const wb = XLSX.utils.book_new();
  sheets.forEach(({ name, data }) => {
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31));
  });
  XLSX.writeFile(wb, filename);
}

export function exportPlayersExcel(players) {
  const data = players.map((p) => ({
    "N°": p.jersey_number ?? "",
    "Prénom": p.first_name,
    "Nom": p.last_name,
    "Poste": p.position || "",
    "Équipe": p.team_name || "",
    "Nationalité": p.nationality || "",
    "Date naissance": p.date_of_birth || "",
    "Statut": p.status,
    "Téléphone": p.phone || "",
    "Email": p.email || "",
    "Début contrat": p.contract_start || "",
    "Fin contrat": p.contract_end || "",
  }));
  exportToExcel(`joueurs-${new Date().toISOString().slice(0, 10)}.xlsx`, [
    { name: "Joueurs", data },
  ]);
}

export function exportFinanceExcel(transactions, summary) {
  const resume = [
    { Indicateur: "Total recettes", Montant_FCFA: summary.total_recette },
    { Indicateur: "Total dépenses", Montant_FCFA: summary.total_depense },
    { Indicateur: "Solde", Montant_FCFA: summary.solde },
  ];
  const tx = transactions.map((t) => ({
    Date: t.transaction_date,
    Description: t.description,
    Catégorie: t.category_name || "",
    Type: t.type,
    Montant_FCFA: t.amount,
    Référence: t.reference || "",
  }));
  const par_cat = (summary.by_category || []).map((c) => ({
    Catégorie: c.name,
    Recettes_FCFA: c.recette,
    Dépenses_FCFA: c.depense,
    Solde_FCFA: c.recette - c.depense,
  }));
  exportToExcel(`finances-${new Date().toISOString().slice(0, 10)}.xlsx`, [
    { name: "Résumé", data: resume },
    { name: "Transactions", data: tx },
    { name: "Par catégorie", data: par_cat },
  ]);
}
